import { render, staticRenderFns } from "./cash_book.vue?vue&type=template&id=90415d60&scoped=true&"
import script from "./cash_book.vue?vue&type=script&lang=js&"
export * from "./cash_book.vue?vue&type=script&lang=js&"
import style0 from "./cash_book.vue?vue&type=style&index=0&id=90415d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90415d60",
  null
  
)

export default component.exports